module.exports = __webpack_public_path__ + "static/NeueMontreal-BoldItalic-8ae0b8a4b19342daa5ad546aebf46666.woff";